// extracted by mini-css-extract-plugin
export default {"contactBtn":"WhiteBtn_contactBtn__jTKFl","contactElement":"WhiteBtn_contactElement__cYI3W"};